import React, {useContext, useState, useEffect, useRef} from 'react';
import _ from "lodash";
import "./studentRegistrationForm.scss"
import {useHistory, withRouter} from "react-router-dom";
import {Formik, Form, Field, FieldArray} from "formik";
import { StoreContext } from '../../store/context'
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select'
import FormControl from '@material-ui/core/FormControl';
import Paper from '@material-ui/core/Paper';
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import {DAYCARE_SUBJECT_ID} from "../../utils/constants";
import { useFormikContext, getIn } from "formik";
import {DatePicker} from "@material-ui/pickers";
import moment from "moment";

const StudentRegistrationForm = () => {
    const history = useHistory();
    const { state, actions } = useContext(StoreContext); // get global state and dispatch function
    const { branch, name, nric, phoneNo, gender, email, uuid, emergencyContactName, emergencyContactPhoneNo, emergencyContactRelationship, schedule  } = state.formStates.studentRegistration; // get field data from global state
    const { setFormData } = actions.formActions; // export setFormData function
    const { getAllTeachers, getAllTuitionFees, getAllMisc } = actions.generalActions;
    const { registerStudent, getAllProgramLvl } = actions.registrationActions;
    const { teachers, tuitionFees, misc } = state.generalStates;
    const studentProgramLvl = state.registrationStates.programLvl;
    const [ courses, setCourses] = useState({});
    const [ programLvl, setProgramLvl] = useState({});

    const formRef = useRef();

    useEffect(() => {
        getAllTeachers();
        getAllTuitionFees();
        getAllMisc();
        getAllProgramLvl();
    }, []);

    const handleTeacherOnChange = (e, { value }, setFieldValue, fieldType) =>{
        setFieldValue(fieldType + ".teacher", e.target.value);
        setFieldValue(fieldType + ".fee", '');
        const programLvlFilter = _.filter(tuitionFees, { teacherId: e.target.value });
        const jsonArray = {...programLvl};
        jsonArray[fieldType] = programLvlFilter;
        setProgramLvl(jsonArray); //program level issue
    };

    const handleProgramLvlOnChange = (e, { value }, setFieldValue, fieldType) =>{
        setFieldValue(fieldType + ".programLvl", e.target.value);
        setFieldValue(fieldType + ".fee", '');
        const coursesFilter = _.filter(programLvl[fieldType], { programLvl: e.target.value });
        const jsonArray = {...courses};
        jsonArray[fieldType] = coursesFilter;
        setCourses(jsonArray);
    };

    const handleCourseOnChange = (e, { value }, setFieldValue, fieldType) =>{
        setFieldValue(fieldType + ".subjectId", e.target.value);
        const subjectFee = _.filter(courses[fieldType], { courseId: e.target.value });
        setFieldValue(fieldType + ".fee", subjectFee[0].fee);
    };

    const handleMiscOnChange = (e, { value }, setFieldValue, fieldType) =>{
        setFieldValue(fieldType + ".id", e.target.value);
        const result = _.filter(misc, { id: e.target.value });
        setFieldValue(fieldType + ".fee", result[0].fee);
    };

    const renderAllCourses = (field, setFieldValue, fieldType) =>{
        if (courses[fieldType] == null) {
            return (
                <Select {...field} onChange={(e, val) => handleCourseOnChange(e, val, setFieldValue, fieldType)}>
                    {
                        tuitionFees && tuitionFees.map((value, index) => {
                            return (
                                <MenuItem key={value.courseId} value={value.courseId}>{value.subjectName}</MenuItem>
                            );
                        })
                    }
                </Select>
            )
        }

        return (
            <Select {...field} onChange={(e, val) => handleCourseOnChange(e, val, setFieldValue, fieldType)}>
                {
                    courses[fieldType] && courses[fieldType].map((value, index) => {
                        return (
                            <MenuItem key={value.courseId} value={value.courseId}>{value.subjectName}</MenuItem>
                        );
                    })
                }
            </Select>
        )
    };

    const renderAllProgramLvl = (field, setFieldValue, fieldType) =>{
        if (programLvl[fieldType] == null && state.registrationStates.programLvl!=null){
            return (
                <Select {...field} onChange={(e, val) => handleProgramLvlOnChange(e, val, setFieldValue, fieldType)}>
                    {
                        tuitionFees && tuitionFees.map((value, index) => {
                            const programLvlObj = _.find(state.registrationStates.programLvl, {id: value.programLvl});
                            if (!programLvlObj) return;
                            return (
                                <MenuItem key={value.programLvl} value={value.programLvl}>{programLvlObj.name}</MenuItem>
                            );
                        })
                    }
                </Select>
            )
        }

        return (
            <Select {...field} onChange={(e, val) => handleProgramLvlOnChange(e, val, setFieldValue, fieldType)}>
                {
                    programLvl[fieldType] && programLvl[fieldType].map((value, index) => {
                        const programLvlName = _.find(state.registrationStates.programLvl, {id: value.programLvl}).name;
                        return (
                            <MenuItem key={value.programLvl} value={value.programLvl}>{programLvlName}</MenuItem>
                        );
                    })
                }
            </Select>
        )
    };


    const renderTeachers = (field, setFieldValue, fieldType) => {
        return (
            <Select {...field} onChange={(e, val) => handleTeacherOnChange(e, val, setFieldValue, fieldType)}>
                {
                    teachers.map((value, index) => {
                        return (
                            <MenuItem key={value.id} value={value.id}>{value.name}</MenuItem>
                        );
                    })
                }
            </Select>
        )
    };

    const renderMiscs = (field, setFieldValue, fieldType) => {
        return (
            <Select {...field} onChange={(e, val) => handleMiscOnChange(e, val, setFieldValue, fieldType)}>
                {
                    misc.map((value, index) => {
                        return (
                            <MenuItem key={value.id} value={value.id}>{value.name}</MenuItem>
                        );
                    })
                }
            </Select>
        )
    };


    const renderTuitionCourse = (values, setFieldValue) =>{
        return (
            <div>
                <FieldArray
                    name="tuitionCourse"
                    render={arrayHelpers => (
                        <div>
                            {values.tuitionCourse.map((value, index) => {
                                return (
                                    <div className="courseContainer" key={index}>
                                        <div className="input-field-container" >
                                            <Field name={`tuitionCourse[${index}].teacher`}>
                                                {({ field, form: { touched, errors } }) => (
                                                    <>
                                                        <FormControl variant="filled" className="input-field">
                                                            <InputLabel>Teacher</InputLabel>
                                                            {renderTeachers(field, setFieldValue, `tuitionCourse[${index}]`)}
                                                        </FormControl>
                                                    </>
                                                )}
                                            </Field>
                                        </div>
                                        <div className="input-field-container" >
                                            <Field name={`tuitionCourse[${index}].programLvl`}>
                                                {({ field, form: { touched, errors } }) => (
                                                    <>
                                                        <FormControl variant="filled" className="input-field">
                                                            <InputLabel>Level</InputLabel>
                                                            {renderAllProgramLvl(field,  setFieldValue, `tuitionCourse[${index}]`)}
                                                        </FormControl>
                                                    </>
                                                )}
                                            </Field>
                                        </div>
                                        <div className="input-field-container" >
                                            <Field name={`tuitionCourse[${index}].subjectId`}>
                                                {({ field, form: { touched, errors } }) => (
                                                    <>
                                                        <FormControl variant="filled" className="input-field">
                                                            <InputLabel>Subject</InputLabel>
                                                            {renderAllCourses(field, setFieldValue, `tuitionCourse[${index}]`)}
                                                        </FormControl>
                                                    </>
                                                )}
                                            </Field>
                                        </div>
                                        <div className="input-field-container" >
                                            <Field name={`tuitionCourse[${index}].effectiveDate`}>
                                                {({ field, form: { touched, errors } }) => (
                                                    <>
                                                        <FormControl variant="filled" className="input-field">
                                                            <DatePicker
                                                                value={field.value ? moment(field.value, "MM-YYYY") : moment()}
                                                                selected={(field.name && new Date(field.name)) || null}
                                                                style={{marginTop: "10px"}}
                                                                className="date-picker"
                                                                views={["year", "month"]}
                                                                label="Effective Date"
                                                                onChange={val => {
                                                                    setFieldValue(`tuitionCourse[${index}].effectiveDate`, val);
                                                                }}
                                                            />
                                                            {/*<div className="inline-error">{errorMsg}</div>*/}
                                                        </FormControl>
                                                    </>
                                                )}
                                            </Field>
                                        </div>
                                        <div className="input-field-container">
                                            <Field name={`tuitionCourse[${index}].fee`}>
                                                {({ field, form: { touched, errors } }) => (
                                                    <>
                                                        <TextField
                                                            {...field}
                                                            label="Fee"
                                                            variant="filled"
                                                            InputProps={{
                                                                startAdornment: <InputAdornment position="start">RM</InputAdornment>,
                                                            }}
                                                            type="number"
                                                            className="input-field"/>
                                                    </>
                                                )}
                                            </Field>
                                        </div>
                                        <div className="button-container">
                                            <IconButton aria-label="delete" onClick={() => arrayHelpers.remove(index)}>
                                                <DeleteIcon/>
                                            </IconButton>
                                        </div>
                                    </div>
                                ) //here
                            })}
                            <div style={{display: "flex", justifyContent: "flex-end", paddingRight: "30px", marginBottom: "12px"}}>
                               <h3>{getTotalAmount(values)}</h3>
                            </div>
                            <div style={{display: "flex", justifyContent: "flex-end", paddingRight: "30px", marginBottom: "12px"}}>
                                <Button variant="contained" color="secondary" onClick={() => arrayHelpers.push({programLvl: 0, subjectName: 0, fee: 0})} className="submit-button">
                                    Add more courses
                                </Button>
                            </div>
                        </div>
                    )}
                />
            </div>
        )
    };

    const getTotalAmount = (values) => {
        let totalAmount = 0;
        if (values.tuitionCourse == null){
            return `Total Amount : ${totalAmount}`;
        }

        for (let i = 0; i < values.tuitionCourse.length; i ++){
            totalAmount += values.tuitionCourse[i].fee;
        }
        return `Total Amount : ${totalAmount}`;
    }

    const renderMisc = (values, setFieldValue) =>{
        return (
            <div>
                <FieldArray
                    name="misc"
                    render={ arrayHelpers => (
                        <div>
                            {values.misc.map((value, index) => {
                                return (
                                    <div className="courseContainer" key={index}>
                                        <div className="input-field-container" >
                                            <Field name={`misc[${index}].id`}>
                                                {({ field, form: { touched, errors } }) => (
                                                    <>
                                                        <FormControl variant="filled" className="input-field">
                                                            <InputLabel>Select Item</InputLabel>
                                                            {renderMiscs(field, setFieldValue, `misc[${index}]`)}
                                                        </FormControl>
                                                    </>
                                                )}
                                            </Field>
                                        </div>

                                        <div className="input-field-container">
                                            <Field name={`misc[${index}].fee`}>
                                                {({ field, form: { touched, errors } }) => (
                                                    <>
                                                        <TextField
                                                            {...field}
                                                            label="Fee"
                                                            variant="filled"
                                                            InputProps={{
                                                                startAdornment: <InputAdornment position="start">RM</InputAdornment>,
                                                            }}
                                                            type="number"
                                                            className="input-field"
                                                            disabled/>
                                                    </>
                                                )}
                                            </Field>
                                        </div>
                                        <div className="button-container">
                                            <IconButton aria-label="delete" onClick={() => arrayHelpers.remove(index)}>
                                                <DeleteIcon/>
                                            </IconButton>
                                        </div>
                                    </div>
                                ) //here
                            })}
                            <div style={{display: "flex", justifyContent: "flex-end", paddingRight: "30px", marginBottom: "12px"}}>
                                <Button variant="contained" color="secondary" onClick={() => arrayHelpers.push({ id : "", name: "", fee: 0 })} className="submit-button">
                                    Add more misc
                                </Button>
                            </div>
                        </div>
                    )}
                />
            </div>
        )
    };

    return (
        <div className="student-form-container">
            <Formik
                innerRef={formRef}
                initialValues={{
                    branch: `${branch ? branch : ''}`,
                    name: `${name ? name : ''}`,
                    nric: `${nric ? nric : ''}`,
                    phoneNo: `${phoneNo ? phoneNo : ''}`,
                    email: `${email ? email : ''}`,
                    gender: `${gender ? gender : ''}`,
                    programLvl: `${programLvl ? programLvl : ''}`,
                    schedule: `${schedule ? schedule : ''}`,
                    emergencyContactName: `${emergencyContactName ? emergencyContactName : ''}`,
                    emergencyContactPhoneNo: `${emergencyContactPhoneNo ? emergencyContactPhoneNo : ''}`,
                    emergencyContactRelationship: `${emergencyContactRelationship ? emergencyContactRelationship : ''}`,
                    tuitionCourse: [ { teacher : "", programLvl: "", subjectId: "", fee: 0 } ],
                    misc: [ { id : "", name: "", fee: 0 } ],
                    enrolmentDate: moment()
                    // tuitionCourse: [ { teacher : 16, programLvl: 1, subjectId: 1, fee: 60 },
                    //     { teacher : 16, programLvl: 1, subjectId: 1, fee: 60 } ],
                    // misc: [ { id : 1, name: "Student Locker", fee: 10 }, { id : 2, name: "Books", fee: 10 } ],
                }}
                onSubmit={(values, { setSubmitting, resetForm }) => {
                    // setFormData({studentRegistration : values}); // pass data to global state
                    // resetForm();
                    registerStudent(values);
                    setSubmitting(false);
                }}
            >
                {({ isSubmitting, setFieldValue, values }) => (
                    <Form>
                            <h1 className="header">Student Registration Form</h1>
                            <h2 className="header">Basic Info</h2>
                            <div className="input-field-container">
                                <Field name="branch">
                                    {({ field, form: { touched, errors } }) => (
                                        <>
                                            <FormControl variant="filled" className="input-field">
                                                <InputLabel>Branch</InputLabel>
                                                <Select {...field}>
                                                    <MenuItem value={"CHUNG_HWA"}>Chung Hwa</MenuItem>
                                                    <MenuItem value={"HENG_EE"}>Heng Ee</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </>
                                    )}
                                </Field>
                            </div>
                            <div className="input-field-container">
                                <Field name="name">
                                    {({ field, form: { touched, errors } }) => (
                                        <>
                                            <TextField {...field} label="Name" variant="filled" className="input-field"/>
                                        </>
                                    )}
                                </Field>
                            </div>
                            <div className="input-field-container">
                                <Field name="nric">
                                    {({ field, form: { touched, errors } }) => (
                                        <>
                                            <TextField {...field} label="NRIC No." variant="filled" className="input-field"/>
                                        </>
                                    )}
                                </Field>
                            </div>

                            <div className="input-field-container">
                                <Field name="gender">
                                    {({ field, form: { touched, errors } }) => (
                                        <>
                                            <FormControl variant="filled" className="input-field">
                                                <InputLabel>Gender</InputLabel>
                                                <Select {...field}>
                                                    <MenuItem value={"M"}>Male</MenuItem>
                                                    <MenuItem value={"F"}>Female</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </>
                                    )}
                                </Field>
                            </div>

                            <div className="input-field-container">
                                <Field name="phoneNo">
                                    {({ field, form: { touched, errors } }) => (
                                        <>
                                            <TextField {...field}
                                               label="Phone No."
                                               variant="filled"
                                               InputProps={{
                                                   startAdornment: <InputAdornment position="start">+60</InputAdornment>,
                                               }}
                                               type="number"
                                               className="input-field"/>
                                        </>
                                    )}
                                </Field>
                            </div>

                            <div className="input-field-container">
                                <Field name="email">
                                    {({ field, form: { touched, errors } }) => (
                                        <>
                                            <TextField type="email" {...field} label="Email" variant="filled" className="input-field"/>
                                        </>
                                    )}
                                </Field>
                            </div>
                            <div className="input-field-container">
                                <Field name="programLvl">
                                    {({ field, form: { touched, errors } }) => (
                                        <>
                                            <FormControl variant="filled" className="input-field">
                                                <InputLabel>Select Program level</InputLabel>
                                                {
                                                    <Select {...field}>
                                                        {
                                                            studentProgramLvl.map((value) => {
                                                                if (value.id === 7) return;
                                                                return (
                                                                    <MenuItem key={value.id} value={value.id}>{value.name}</MenuItem>
                                                                );
                                                            })
                                                        }
                                                    </Select>
                                                }
                                            </FormControl>
                                        </>
                                    )}
                                </Field>
                            </div>

                            <div className="input-field-container">
                                <Field name="schedule">
                                    {({ field, form: { touched, errors } }) => (
                                        <>
                                            <FormControl variant="filled" className="input-field">
                                                <InputLabel>Schedule</InputLabel>
                                                <Select {...field}>
                                                    <MenuItem value={"MORNING"}>Morning</MenuItem>
                                                    <MenuItem value={"AFTERNOON"}>Afternoon</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </>
                                    )}
                                </Field>
                            </div>

                            <div className="input-field-container">
                                <Field name="enrolmentDate">
                                    {({ field, form: { touched, errors } }) => (
                                        <>
                                            <FormControl variant="filled" className="input-field">
                                                <DatePicker
                                                    {...field}
                                                    selected={(field.name && new Date(field.name)) || null}
                                                    style={{marginTop: "10px"}}
                                                    className="date-picker"
                                                    views={["year", "month"]}
                                                    label="Enrolment Date"
                                                    onChange={val => {
                                                        setFieldValue(field.name, val);
                                                    }}
                                                />
                                                {/*<div className="inline-error">{errorMsg}</div>*/}
                                            </FormControl>
                                        </>
                                    )}
                                </Field>
                            </div>

                            <h2 className="header">Emergency Contact</h2>
                            <div className="input-field-container">
                                <Field name="emergencyContactName">
                                    {({ field, form: { touched, errors } }) => (
                                        <>
                                            <TextField {...field} label="Name" variant="filled" className="input-field"/>
                                        </>
                                    )}
                                </Field>
                            </div>

                            <div className="input-field-container">
                                <Field name="emergencyContactPhoneNo">
                                    {({ field, form: { touched, errors } }) => (
                                        <>
                                            <TextField {...field}
                                                       label="Phone No."
                                                       variant="filled"
                                                       InputProps={{
                                                           startAdornment: <InputAdornment position="start">+60</InputAdornment>,
                                                       }}
                                                       type="number"
                                                       className="input-field"/>
                                        </>
                                    )}
                                </Field>
                            </div>

                            <div className="input-field-container">
                                <Field name="emergencyContactRelationship">
                                    {({ field, form: { touched, errors } }) => (
                                        <>
                                            <>
                                                <TextField {...field} label="Relationship" variant="filled" className="input-field"/>
                                            </>
                                        </>
                                    )}
                                </Field>
                            </div>

                            <h2 className="header">Courses</h2>
                            {renderTuitionCourse(values, setFieldValue)}

                            {/*<h2 className="header">Misc</h2>*/}
                            {/*{ renderMisc(values, setFieldValue) }*/}

                            {/*add few fields*/}


                            {/* default submit button will fire  "onSubmit" function when clicked */}
                            <div>
                                <Button variant="contained" type="submit" color="primary" disabled={isSubmitting} className="submit-button">
                                    Submit
                                </Button>
                            </div>
                    </Form>
                )}
            </Formik>
        </div>
    )
}

export default withRouter(StudentRegistrationForm);
